// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Core__List = require("@rescript/core/src/Core__List.bs.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Caml_option = require("rescript/lib/js/caml_option.js");

function make(fn) {
  return fn;
}

function noop() {
  
}

function unsubscribe(t) {
  if (!t.closed) {
    t.closed = true;
    return t.unsubscribe();
  }
  
}

function make$1(unsubscribe) {
  return {
          unsubscribe: unsubscribe,
          closed: false
        };
}

var Subscription = {
  unsubscribe: unsubscribe,
  make: make$1
};

function shouldStop(e) {
  if (typeof e !== "object" || e.TAG !== "Next") {
    return true;
  } else {
    return false;
  }
}

var $$Event = {
  shouldStop: shouldStop
};

function make$2(fn) {
  return fn;
}

function on($$event, t) {
  return t($$event);
}

function next(v, t) {
  t({
        TAG: "Next",
        _0: v
      });
}

function emit($$event, t) {
  if (!t.stopped) {
    t.stopped = shouldStop($$event);
    var __x = t.emit;
    return __x($$event);
  }
  
}

function unsubscribe$1(t) {
  t.stopped = true;
}

function make$3(emit) {
  return {
          emit: emit,
          stopped: false
        };
}

function next$1(v, t) {
  emit({
        TAG: "Next",
        _0: v
      }, t);
}

function complete(t) {
  emit("Complete", t);
}

function error(e, t) {
  emit({
        TAG: "Error",
        _0: e
      }, t);
}

var Emitter_Observer = {
  make: make$2,
  on: on
};

var Emitter = {
  $$Event: $$Event,
  emit: emit,
  Observer: Emitter_Observer,
  make: make$3,
  unsubscribe: unsubscribe$1
};

function onSubscribe(emitter, t) {
  return t(emitter);
}

function make$4(fn) {
  return fn;
}

var Source = {
  Emitter: Emitter,
  make: make$4,
  onSubscribe: onSubscribe
};

var include = (function (param) {
      var make$5 = function (source) {
        return {
                source: source
              };
      };
      var fromFn = function (fn) {
        return make$5(param.make(fn));
      };
      var subscribe = function (observer, t) {
        var emitter = make$3(observer);
        var subscription = param.onSubscribe(emitter, t.source);
        return {
                unsubscribe: (function () {
                    unsubscribe$1(emitter);
                    subscription();
                  }),
                closed: false
              };
      };
      var subscribeFn = function (fn, t) {
        return subscribe(make$2(fn), t);
      };
      return {
              make: make$5,
              fromFn: fromFn,
              subscribe: subscribe,
              subscribeFn: subscribeFn
            };
    })(Source);

var fromFn = include.fromFn;

var subscribe = include.subscribe;

var subscribeFn = include.subscribeFn;

function fromPromise(promise) {
  return fromFn(function (emitter) {
              ((function (__x) {
                      return Js_promise.$$catch((function (err) {
                                    error(err, emitter);
                                    return Promise.resolve();
                                  }), __x);
                    })((function (__x) {
                          return Js_promise.then_((function (result) {
                                        next$1(result, emitter);
                                        emit("Complete", emitter);
                                        return Promise.resolve();
                                      }), __x);
                        })(promise)));
              return noop;
            });
}

function onNext(onCompleteOpt, onErrorOpt, onNext$1, t) {
  var onComplete = onCompleteOpt !== undefined ? onCompleteOpt : (function () {
        
      });
  var onError = onErrorOpt !== undefined ? onErrorOpt : (function (param) {
        
      });
  return subscribeFn((function ($$event) {
                if (typeof $$event !== "object") {
                  return onComplete();
                } else if ($$event.TAG === "Next") {
                  return onNext$1($$event._0);
                } else {
                  return onError($$event._0);
                }
              }), t);
}

function shouldStop$1(param) {
  return true;
}

var $$Event$1 = {
  shouldStop: shouldStop$1
};

function make$5(fn) {
  return fn;
}

function on$1($$event, t) {
  return t($$event);
}

function emit$1($$event, t) {
  if (!t.stopped) {
    t.stopped = $$Event$1.shouldStop($$event);
    var __x = t.emit;
    return on$1($$event, __x);
  }
  
}

function unsubscribe$2(t) {
  t.stopped = true;
}

function make$6(emit) {
  return {
          emit: emit,
          stopped: false
        };
}

function ok(v, e) {
  emit$1({
        TAG: "Ok",
        _0: v
      }, e);
}

function error$1(e, v) {
  emit$1({
        TAG: "Error",
        _0: e
      }, v);
}

var Emitter_Observer$1 = {
  make: make$5,
  on: on$1
};

var Emitter$1 = {
  $$Event: $$Event$1,
  emit: emit$1,
  Observer: Emitter_Observer$1,
  make: make$6,
  unsubscribe: unsubscribe$2
};

function onSubscribe$1(emitter, t) {
  return t(emitter);
}

function make$7(fn) {
  return fn;
}

var Source$1 = {
  Emitter: Emitter$1,
  make: make$7,
  onSubscribe: onSubscribe$1
};

var include$1 = (function (param) {
      var make$8 = function (source) {
        return {
                source: source
              };
      };
      var fromFn = function (fn) {
        return make$8(param.make(fn));
      };
      var subscribe = function (observer, t) {
        var emitter = make$6(observer);
        var subscription = param.onSubscribe(emitter, t.source);
        return {
                unsubscribe: (function () {
                    unsubscribe$2(emitter);
                    subscription();
                  }),
                closed: false
              };
      };
      var subscribeFn = function (fn, t) {
        return subscribe(make$5(fn), t);
      };
      return {
              make: make$8,
              fromFn: fromFn,
              subscribe: subscribe,
              subscribeFn: subscribeFn
            };
    })(Source$1);

var fromFn$1 = include$1.fromFn;

function fromPromise$1(promise) {
  return fromFn$1(function (emitter) {
              ((function (__x) {
                      return Js_promise.$$catch((function (err) {
                                    error$1(err, emitter);
                                    return Promise.resolve();
                                  }), __x);
                    })((function (__x) {
                          return Js_promise.then_((function (result) {
                                        ok(result, emitter);
                                        return Promise.resolve();
                                      }), __x);
                        })(promise)));
              return noop;
            });
}

function observer(t) {
  return function ($$event) {
    Core__List.forEach(t.subscribers, (function (extra) {
            return emit($$event, extra);
          }));
  };
}

function observable(t) {
  return fromFn(function (emitter) {
              t.subscribers = Core__List.add(t.subscribers, emitter);
              return function () {
                t.subscribers = Core__List.filter(t.subscribers, (function (x) {
                        return x !== emitter;
                      }));
                emitter.stopped = true;
              };
            });
}

function make$8() {
  return {
          subscribers: /* [] */0
        };
}

var Subject = {
  observer: observer,
  observable: observable,
  make: make$8
};

function lift(fn, observable) {
  return fromFn(function (emitter) {
              var observer = fn(emitter);
              var subscription = subscribeFn(observer, observable);
              return function () {
                unsubscribe(subscription);
              };
            });
}

function last(observable) {
  var result = {
    contents: undefined
  };
  return lift((function (emitter) {
                return function ($$event) {
                  if (typeof $$event === "object") {
                    if ($$event.TAG === "Next") {
                      result.contents = Caml_option.some($$event._0);
                      return ;
                    } else {
                      return error($$event._0, emitter);
                    }
                  }
                  next$1(result.contents, emitter);
                  emit("Complete", emitter);
                };
              }), observable);
}

function map(fn, observable) {
  return lift((function (emitter) {
                return function ($$event) {
                  if (typeof $$event !== "object") {
                    return emit("Complete", emitter);
                  } else if ($$event.TAG === "Next") {
                    return next$1(fn($$event._0), emitter);
                  } else {
                    return error($$event._0, emitter);
                  }
                };
              }), observable);
}

function toArray(o) {
  var fn = function (acc, x) {
    return acc.concat([x]);
  };
  var initial = [];
  var acc = {
    contents: initial
  };
  return lift((function (emitter) {
                return function ($$event) {
                  if (typeof $$event === "object") {
                    if ($$event.TAG === "Next") {
                      acc.contents = fn(acc.contents, $$event._0);
                      return ;
                    } else {
                      return error($$event._0, emitter);
                    }
                  }
                  next$1(acc.contents, emitter);
                  emit("Complete", emitter);
                };
              }), o);
}

function filter(fn, observable) {
  return lift((function (emitter) {
                return function ($$event) {
                  if (typeof $$event !== "object") {
                    return emit("Complete", emitter);
                  }
                  if ($$event.TAG !== "Next") {
                    return error($$event._0, emitter);
                  }
                  var value = $$event._0;
                  if (fn(value)) {
                    return next$1(value, emitter);
                  }
                  
                };
              }), observable);
}

function partition(fn, observable) {
  return [
          filter(fn, observable),
          filter((function (extra) {
                  return !fn(extra);
                }), observable)
        ];
}

function defer(fn) {
  return fromFn(function (emitter) {
              var observable = fn();
              var subscription = subscribeFn((function ($$event) {
                      emit($$event, emitter);
                    }), observable);
              return function () {
                unsubscribe(subscription);
              };
            });
}

function flatMap(fn, observable) {
  return fromFn(function (emitter) {
              var subscription = subscribeFn((function ($$event) {
                      if (typeof $$event !== "object") {
                        return emit("Complete", emitter);
                      }
                      if ($$event.TAG !== "Next") {
                        return error($$event._0, emitter);
                      }
                      var o = fn($$event._0);
                      subscribeFn((function ($$event) {
                              emit($$event, emitter);
                            }), o);
                    }), observable);
              return function () {
                unsubscribe(subscription);
              };
            });
}

function publish(observable$1) {
  var subject = {
    subscribers: /* [] */0
  };
  var subscription = subscribe(observer(subject), observable$1);
  return fromFn(function (emitter) {
              var o = observable(subject);
              var subscription2 = subscribeFn((function ($$event) {
                      emit($$event, emitter);
                    }), o);
              return function () {
                unsubscribe(subscription2);
                unsubscribe(subscription);
              };
            });
}

function fromArray(arr) {
  return fromFn(function (emitter) {
              arr.forEach(function (e) {
                    next$1(e, emitter);
                  });
              emit("Complete", emitter);
              return noop;
            });
}

var Unsubscriber = {
  noop: noop,
  make: make
};

var Observable_Event = {};

var Observable_Emitter = {
  emit: emit,
  next: next$1,
  complete: complete,
  error: error
};

var Observable_Source = {
  make: make$4
};

var Observable_Observer = {
  make: make$2,
  on: on,
  next: next
};

var Observable_make = include.make;

var Observable = {
  $$Event: Observable_Event,
  Emitter: Observable_Emitter,
  Source: Observable_Source,
  Observer: Observable_Observer,
  Subscription: Subscription,
  subscribe: subscribe,
  subscribeFn: subscribeFn,
  make: Observable_make,
  fromFn: fromFn,
  fromPromise: fromPromise,
  onNext: onNext
};

var Single_Event = {};

var Single_Emitter = {
  emit: emit$1,
  ok: ok
};

var Single_Source = {
  make: make$7
};

var Single_Observer = {
  make: make$5,
  on: on$1
};

var Single_subscribe = include$1.subscribe;

var Single_subscribeFn = include$1.subscribeFn;

var Single_make = include$1.make;

var Single = {
  $$Event: Single_Event,
  Emitter: Single_Emitter,
  Source: Single_Source,
  Observer: Single_Observer,
  Subscription: Subscription,
  subscribe: Single_subscribe,
  subscribeFn: Single_subscribeFn,
  make: Single_make,
  fromFn: fromFn$1,
  fromPromise: fromPromise$1
};

var Operators = {
  defer: defer,
  last: last,
  map: map,
  toArray: toArray,
  filter: filter,
  partition: partition,
  flatMap: flatMap,
  fromArray: fromArray,
  publish: publish
};

exports.Unsubscriber = Unsubscriber;
exports.Subscription = Subscription;
exports.Observable = Observable;
exports.Single = Single;
exports.Subject = Subject;
exports.Operators = Operators;
/* include Not a pure module */
